export const GOAL_TYPES = [
  { value: "lose_weight", label: "Lose weight", hasTarget: true, unit: "kg" },
  { value: "build_strength", label: "Build strength", hasTarget: false },
  { value: "get_fit", label: "General fitness", hasTarget: false },
  { value: "improve_mobility", label: "Move better", hasTarget: false },
  { value: "reduce_stress", label: "Reduce stress", hasTarget: false },
];

export const TIMEFRAMES = [
  { value: 1, label: "1 month" },
  { value: 3, label: "3 months" },
  { value: 6, label: "6 months" },
];

export const ONBOARDING_STEPS = [
  {
    key: "goal",
    type: "goal",
    question: "What's your goal?",
  },
  {
    key: "experience",
    type: "single",
    question: "How much fitness experience do you have?",
    options: [
      { value: "beginner", label: "Complete beginner" },
      { value: "some_experience", label: "Some experience" },
      { value: "experienced", label: "Quite experienced" },
    ],
  },
  {
    key: "injuries",
    type: "multi",
    question: "Any injuries Kaizen should know about?",
    options: [
      { value: "knee", label: "Knee" },
      { value: "back", label: "Back" },
      { value: "shoulder", label: "Shoulder" },
    ],
    noneOption: true,
  },
  {
    key: "days_per_week",
    type: "single",
    question: "How many days a week feel realistic?",
    options: [2, 3, 4, 5, 6].map((n) => ({ value: n, label: `${n} days` })),
  },
  {
    key: "session_minutes",
    type: "single",
    question: "How long can a session usually be?",
    options: [15, 30, 45, 60].map((n) => ({ value: n, label: `${n} minutes` })),
  },
  {
    key: "equipment_tier",
    type: "single",
    question: "What equipment do you have access to?",
    options: [
      { value: "home_none", label: "No equipment, just my body" },
      { value: "home_dumbbells", label: "A few dumbbells at home" },
      { value: "gym_machines", label: "Gym with machines" },
      { value: "gym_free_weights", label: "Full gym access" },
    ],
  },
  {
    key: "preferred_time",
    type: "single",
    question: "When do you usually prefer to train?",
    options: [
      { value: "morning", label: "Morning" },
      { value: "afternoon", label: "Afternoon" },
      { value: "evening", label: "Evening" },
      { value: "night", label: "Night" },
    ],
  },
  {
    key: "diet_pref",
    type: "single",
    question: "What do you usually eat?",
    options: [
      { value: "veg", label: "Vegetarian" },
      { value: "nonveg", label: "Non-vegetarian" },
    ],
  },
  {
    key: "red_flags",
    type: "multi",
    question: "Quick safety check — do any of these apply to you right now?",
    isRedFlag: true,
    options: [
      { value: "chest_pain", label: "Chest pain during activity" },
      { value: "pregnancy", label: "Pregnancy with complications" },
      { value: "recent_surgery", label: "Recent surgery" },
      { value: "uncontrolled_bp_diabetes", label: "Uncontrolled blood pressure or diabetes" },
      { value: "doctor_restriction", label: "A doctor has advised against exercise" },
    ],
    noneOption: true,
  },
  { key: "age", type: "number", question: "How old are you?" },
  {
    key: "gender",
    type: "single",
    question: "How do you identify?",
    optional: true,
    note: "Helps Kaizen tune your starting plan.",
    options: [
      { value: "female", label: "Female" },
      { value: "male", label: "Male" },
      { value: "prefer_not_to_say", label: "Prefer not to say" },
    ],
  },
];
